import axios from "axios";
import apiURI from "./Api";

export default class CompanyDiagnosisService {
  async createDiagnosis(token, diagnosis) {
    const response = await axios({
      method: "post",
      url: `${apiURI}/company-diagnosis/create`,
      data: { company_diagnosis: diagnosis },
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  }

  async getAllDiagnoses(token) {
    const response = await axios({
      method: "get",
      url: `${apiURI}/company-diagnosis/getAll`,
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  }

  async getDiagnosisById(token, id) {
    const response = await axios({
      method: "get",
      url: `${apiURI}/company-diagnosis/getById/${id}`,
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  }

  async updateDiagnosis(token, id, diagnosis) {
    const response = await axios({
      method: "post",
      url: `${apiURI}/company-diagnosis/update/${id}`,
      data: { company_diagnosis: diagnosis },
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  }

  async deleteDiagnosis(token, id) {
    const response = await axios({
      method: "delete",
      url: `${apiURI}/company-diagnosis/delete/${id}`,
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  }
}

